function areArraysEqual(left: unknown[], right: unknown[]): boolean {
  if (left.length !== right.length) {
    return false;
  }

  return left.every((value, index) => value === right[index]);
}

export function areDraftsEqual<T extends object>(left: T, right: T): boolean {
  const leftRecord = left as Record<string, unknown>;
  const rightRecord = right as Record<string, unknown>;
  const leftKeys = Object.keys(leftRecord);
  const rightKeys = Object.keys(rightRecord);

  if (leftKeys.length !== rightKeys.length) {
    return false;
  }

  return leftKeys.every((key) => {
    const leftValue = leftRecord[key];
    const rightValue = rightRecord[key];

    if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
      return areArraysEqual(leftValue, rightValue);
    }

    return leftValue === rightValue;
  });
}

export function areDraftArraysEqual<T extends object>(left: T[], right: T[]): boolean {
  if (left.length !== right.length) {
    return false;
  }

  return left.every((item, index) => {
    const rightItem = right[index];
    return rightItem ? areDraftsEqual(item, rightItem) : false;
  });
}
